import { render, staticRenderFns } from "./task_preview_widget.vue?vue&type=template&id=8ee2fc46&scoped=true"
import script from "./task_preview_widget.vue?vue&type=script&lang=js"
export * from "./task_preview_widget.vue?vue&type=script&lang=js"
import style0 from "./task_preview_widget.vue?vue&type=style&index=0&id=8ee2fc46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ee2fc46",
  null
  
)

export default component.exports